import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Http } from "@angular/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { GlobalVar } from "../../global-var";
import * as moment from "moment";
import swal from "sweetalert2";
import { fadeInOutTranslate } from "../../shared/elements/animation";
import {
  NgxImageGalleryComponent,
  GALLERY_IMAGE,
  GALLERY_CONF
} from "ngx-image-gallery";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AdminLayoutComponent } from "../../layouts/admin/admin-layout.component";
import { Location } from "@angular/common";
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "../../translate.service";
import { ToastyService, ToastOptions, ToastData } from "ng2-toasty";
@Component({
  selector: "app-dashboard3",
  templateUrl: "./dashboard3.component.html",
  styleUrls: ["./dashboard3.component.css"],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInOutTranslate]
})
export class Dashboard3Component implements OnInit {
  lang = localStorage.getItem("lang");
  x;
  y;
  card_data2 = [];
  card_data = [];
  vehicleID_data = [];
  card_status = 1;
  v_idBar = [];
  v_id = '';
  car_status = [];
  warning_percent = 0;
  counter = 30;
  selected_imei = null;
  warning_number = 0;
  radio_select = "3";
  all_card_data = [];
  warning_count = 0;
  heartbeat_count = 0;
  selectvid;
  toggle;
  hosts = this._g.hosts;
  warning_array;
  select_url1 = "";
  select_url2 = "";
  select_url3 = "";
  select_url4 = "";
  select_name = "";
  select_card_status = "1";
  select_video_status = "0";
  realtimecam_bool = false;
  select_lat = 0;
  select_lon = 0;
  options = {
    responsive: true,
    maintainAspectRatio: false
  };
  outDash_user = null;
  select_group = null;
  loading2 = false;
  usergroup = [];
  sound_arr = [];
  notification_arr = [];
  toasty_option = {
    title: "Default Toasty",
    msg: "Turning standard Bootstrap alerts into awesome notifications",
    timeout: 5000,
    theme: "default",
    position: "bottom-right",
    type: "warning"
  };
  @ViewChild(NgxImageGalleryComponent)
  ngxImageGallery: NgxImageGalleryComponent;
  // gallery configuration
  conf: GALLERY_CONF = {
    imageOffset: "0px",
    showDeleteControl: false,
    showImageTitle: false
  };

  // gallery images
  images: GALLERY_IMAGE[] = [];

  //chart
  type4 = "pie";
  data4 = {
    labels: ["No data"],
    datasets: [
      {
        data: [],
        backgroundColor: [
          "#e80404",
          "#e85304",
          "#e8d104",
          "#94e804",
          "#0fe804",
          "#04e8ab",
          "#049fe8",
          "#040be8",
          "#7204e8",
          "#e004e8",
          "#e8046e"
        ],
        hoverBackgroundColor: ["#6cc4fb", "#ffb59f", "#0dedf7"]
      }
    ]
  };
  constructor(
    private _g: GlobalVar,
    private _http: Http,
    private _sanitizer: DomSanitizer,
    private router: Router,
    private adminlayout: AdminLayoutComponent,
    private activatedRoute: ActivatedRoute,
    private _location: Location,
    private translate: TranslateService,
    private toastyService: ToastyService
  ) {
    this.get_usercameragroup();
    if (this.router.url.split("?")[0] == "/outdashboard") {
      localStorage.clear();
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        let username = params["user"];
        let password = params["pwd"];
        this.hosts = "https://dtcivms:1000/";
        this.outDashboard(username, password);
      });
      // this.hosts = localStorage.getItem("node_server")
      // this.get_intitialInfo('all')
    } else {
      if (this._g.role == "1") {
        this.get_intitialInfo("all", this.select_group);
        this.adminlayout.menuControl();
      } else {
        this.get_intitialInfo(
          localStorage.getItem("node_user"),
          this.select_group
        );
        this.adminlayout.menuControl();
      }
    }
    
  }

  ngOnInit() {
    this.get_soundsetting();
    this.y = setInterval(() => {
      this.timetick();
      this.run_notitfication();
    }, 1000);
    setTimeout(() => {
      if (this.router.url.split("?")[0] == "/outdashboard") {
        this.get_intitialInfo(this.outDash_user, this.select_group);
      } else {
        if (this._g.role == "1") {
          this.get_intitialInfo("all", this.select_group);
        } else {
          this.get_intitialInfo(
            localStorage.getItem("node_user"),
            this.select_group
          );
        }
      }
    }, 3000);
  }
  ngOnDestroy() {
    clearInterval(this.x);
    clearInterval(this.y);
  }
  timetick() {
    this.counter--;
    if (this.counter == 0) {
      this.counter = 30;
      if (this.router.url.split("?")[0] == "/outdashboard") {
        this.get_intitialInfo(this.outDash_user, this.select_group);
      } else {
        if (this._g.role == "1") {
          this.get_intitialInfo("all", this.select_group);
        } else {
          this.get_intitialInfo(
            localStorage.getItem("node_user"),
            this.select_group
          );
        }
      }
    }
  }

  playAudio(number) {
    let audio = new Audio();
    audio.src = "/assets/sound/" + number + ".mp3";
    audio.load();
    audio.play();
  }

  run_notitfication() {
    if (this.notification_arr.length > 0) {
      let temp = this.notification_arr.pop();
      if (temp) {
        if (this.sound_arr.length > 0) {
          let temp2 = this.sound_arr.filter(
            x => x.warning_type == temp.status_value
          );
          this.playAudio(temp2.length > 0 ? temp2[0].sound_no : "0");
        }
        let toasty_option = {
          title: `Warning : ${temp.plate_number}`,
          msg: `${temp.warning_type}`,
          timeout: 5000,
          theme: "default",
          position: "bottom-right",
          type: "warning"
        };
        this.addToast(toasty_option);
      }
    }
  }

  get_soundsetting() {
    this._http
      .get(
        this._g.hosts +
          "get_sound_setting?username=" +
          localStorage.getItem("node_user")
      )
      .map(data => data.json())
      .subscribe(res => {
        if (Array.isArray(res)) {
          if (res.length > 0) {
            this.sound_arr = res;
          }
        }
      });
  }
  addToast(options) {
    if (options.closeOther) {
      this.toastyService.clearAll();
    }
    let toastOptions: ToastOptions = {
      title: options.title,
      msg: options.msg,
      showClose: options.showClose,
      timeout: options.timeout,
      theme: options.theme,
      onAdd: (toast: ToastData) => {
        // console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: (toast: ToastData) => {
        // console.log('Toast ' + toast.id + ' has been added removed!');
      }
    };
    switch (options.type) {
      case "default":
        this.toastyService.default(toastOptions);
        break;
      case "info":
        this.toastyService.info(toastOptions);
        break;
      case "success":
        this.toastyService.success(toastOptions);
        break;
      case "wait":
        this.toastyService.wait(toastOptions);
        break;
      case "error":
        this.toastyService.error(toastOptions);
        break;
      case "warning":
        this.toastyService.warning(toastOptions);
        break;
    }
  }

  get_intitialInfo(x, y) {
    y = y == null ? "" : y;
    let old_warning = this.all_card_data.filter(
      x => x.warning_type != this.translate.data.heartbeat
    );
    this._http
      .get(this.hosts + "get_MomentaWarning?value=")
      .map(data => data.json())
      .subscribe(data => {
        this.warning_array = data;
        this._http
        .get(this.hosts + "get_MomentaDashboardAll?value=" + x + "&group=" + y)
        .map(data => data.json())
        .subscribe(data => {
          if (data.length > 0) {
            for (let i in data) {
              if (data[i].speed == 0) {
                data[i].speed = "-";
              }
              data[i].status_value = data[i].warning_type;
              data[i].onoff =
                moment().diff(data[i].timestamp, "minutes") > 10 ? 1 : 0;
              data[i].timestamp = moment(data[i].timestamp).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              if (data[i].warning_type != "") {
                let temp = this.warning_array.filter(x => {
                  return x.status_value == data[i].warning_type;
                })[0];
                if (temp != undefined) {
                  if (this.lang == "TH") {
                    data[i].warning_type = temp.status_nameth;
                  } else if (this.lang == "EN") {
                    data[i].warning_type = temp.status_nameen;
                  }
                }
              } else {
                data[i].warning_type = this.translate.data.heartbeat;
              }
            }
            var temp = groupBy(data, "warning_type");
  
            let warning_label = temp.map(x => x[0].warning_type);
            let data_chart = temp.map(x => x.length);
            var hexcolor = [];
            for (let i in temp) {
              hexcolor.push(
                this.warning_array.filter(x => {
                  if (
                    x.status_nameth == temp[i][0].warning_type ||
                    x.status_nameen == temp[i][0].warning_type
                  ) {
                    return true;
                  } else {
                    return false;
                  }
                })
              );
            }
            hexcolor = hexcolor.map(x => {
              if (x.length > 0) {
                return x[0].status_color;
              } else {
                return "#0fe804";
              }
            });
            this.data4 = {
              labels: warning_label,
              datasets: [
                {
                  data: data_chart,
                  backgroundColor: hexcolor,
                  hoverBackgroundColor: hexcolor
                }
              ]
            };
          }
          this.warning_count = data.filter(
            x => x.warning_type != this.translate.data.heartbeat
          ).length;
          this.heartbeat_count = data.filter(
            x => x.warning_type == this.translate.data.heartbeat
          ).length;
          this.all_card_data = data;
          // debugger
          if (this.radio_select == "2") {
            this.card_data = data.filter(
              x => x.warning_type == this.translate.data.heartbeat
            );
          } else if (this.radio_select == "3") {
            this.card_data = data.filter(
              x => x.warning_type != this.translate.data.heartbeat
            );
          } else {
            this.card_data = data;
          }
  
          let new_warning = data.filter(
            x => x.warning_type != this.translate.data.heartbeat
          );
          for (let i in new_warning) {
            let search_value = old_warning.find(
              x =>
                x.imei == new_warning[i].imei &&
                moment(x.timestamp).isSame(moment(new_warning[i].timestamp))
            );
  
            if (search_value) {
            } else {
              this.notification_arr.push(new_warning[i]);
            }
          }
        });
      });
   
    setTimeout(() => {
      y = this.select_group == null ? "" : y;
      this._http
        .get(
          this.hosts + "get_MomentaDashboardStatus?value=" + x + "&group=" + y
        )
        .map(data => data.json())
        .subscribe(data => {
          if (data.length > 0) {
            for (let i in data) {
              data[i].onoff =
                moment().diff(data[i].timestamp, "minutes") < 5 ? 1 : 0;
            }
            this.v_idBar = data.map(x => x.plate_number);
            this.car_status = data;

            this.warning_percent =
              (this.warning_count / this.v_idBar.length) * 100;

            this.warning_number = this.warning_count;

            for (let i in this.all_card_data) {
              if (
                this.all_card_data[i].warning_type !=
                this.translate.data.heartbeat
              ) {
                this.warning_number++;
              }
            }
          }
        });
    }, 500);
  }

  get_specifyData(y) {
    this.loading2 = true;
    var x = this.car_status.filter(a => a.plate_number == y);
    this.card_status = 2;
    this.card_data2 = [];
    // debugger
    let body = { imei: x[0].imei };
    this.selected_imei = x[0];
    this.selectvid = y;

    this._http
      .post(this.hosts + "get_MomentaSpecifyRealtime", body)
      .map(data => data.json())
      .subscribe(data => {
        if (data.length > 0) {
          // debugger
          this.loading2 = false;
          this.images = data.map(x => {
            return {
              url: x.url,
              altText: x.imei,
              extUrl: x.url,
              thumbnailUrl: x.url
            };
          });
          for (let i in data) {
            if (data[i].speed == 0) {
              data[i].speed = "-";
            }
            data[i].onoff =
              moment().diff(data[i].timestamp, "minutes") > 10 ? 1 : 0;
            data[i].timestamp = moment(data[i].timestamp).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (this.lang == "TH") {
              data[i].warning_type = this.warning_array.filter(x => {
                return x.status_value == data[i].warning_type;
              })[0].status_nameth;
            } else if (this.lang == "EN") {
              data[i].warning_type = this.warning_array.filter(x => {
                return x.status_value == data[i].warning_type;
              })[0].status_nameen;
            }
          }
          var temp = groupBy(data, "warning_type");
        }
        this.card_data2 = data;
      });

    this._http
      .post(this._g.hosts + "get_specificRealtimeCam", body)
      .map(data => data.json())
      .subscribe(data => {
        if (data.length > 0) {
          this.realtimecam_bool = true;
          this.select_url1 = data[0].url1;
          this.select_url2 = data[0].url2;
          this.select_url3 = data[0].url3;
          this.select_url4 = data[0].url4;
          this.select_name = data[0].plate_number;
          this.select_lat = data[0].latitude;
          this.select_lon = data[0].longitude;
        } else {
          this.realtimecam_bool = false;
        }
      });
  }

  autocompleListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.plate_number}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  openGallery(index: number = 0) {
    this.ngxImageGallery.open(index);
  }

  // close gallery
  closeGallery() {
    this.ngxImageGallery.close();
  }

  // set new active(visible) image in gallery
  newImage(index: number = 0) {
    this.ngxImageGallery.setActiveImage(index);
  }

  // next image in gallery
  nextImage(index: number = 0) {
    this.ngxImageGallery.next();
  }

  // prev image in gallery
  prevImage(index: number = 0) {
    this.ngxImageGallery.prev();
  }

  backPage() {
    this.card_status = 1;
    this.selected_imei = null;
  }
  checkTest(x) {
    this.radio_select = x;
    if (this.router.url.split("?")[0] == "/outdashboard") {
      this.get_intitialInfo(this.outDash_user, this.select_group);
    } else {
      if (this._g.role == "1") {
        this.get_intitialInfo("all", this.select_group);
      } else {
        this.get_intitialInfo(
          localStorage.getItem("node_user"),
          this.select_group
        );
      }
    }
  }
  @ViewChild("videoPlayer") videoplayer: any;

  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }
  closeModel() {
    this.select_lat = 0;
    this.select_lon = 0;
  }
  @ViewChild("t") t: NgbTabset;
  open() {
    setTimeout(() => {
      this.t.select("realtime");
    }, 500);

    //t.select('realtime')
  }

  outDashboard(username, password) {
    password = atob(password);
    let body1 = { username: username, password: password };
    this._http.post(this.hosts + "get_momentaLogin", body1).subscribe(data => {
      if (data.text() == "unpass") {
        swal({
          title: "เข้าสู่ระบบล้มเหลว",
          text: "รหัสผ่านผิด",
          type: "error"
        });
        this._location.back();
      } else if (data.text() == "no user") {
        swal({
          title: "ไม่มีชื่อผู้ใช้นี้ในระบบ",
          text: "ลองเช้คเชื่อผู้ใช้อีกรอบ",
          type: "error"
        });
        this._location.back();
      } else {
        this.outDash_user = data.text() == "1" ? "all" : username;
        this.get_intitialInfo(this.outDash_user, this.select_group);
      }
    });
  }
  onchangeGroup(x) {}

  get_usercameragroup() {
    this._http
      .get(this._g.hosts + "get_usergroupname?username=" + this._g.usernames)
      .map(data => data.json())
      .subscribe(data => {
        if (data.length > 0) {
          this.usergroup = data;
        }
      });
  }
}

function groupBy(collection, property) {
  var i = 0,
    val,
    index,
    values = [],
    result = [];
  for (; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1) result[index].push(collection[i]);
    else {
      values.push(val);
      result.push([collection[i]]);
    }
  }
  return result;
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/camera-config/dashboard3/dashboard3.component.ts